import { LifecycleEvent, notifyNmaOfHybridLifecycleEvent } from '@chewy/nma-utils';
import { useEffect } from 'react';

/**
 *
 * READY_TO_DISPLAY = Indicates when web content is ready to display/be consumed by the user
 * more details: https://chewyinc.atlassian.net/wiki/spaces/NID/pages/2257390037/Hybrid+Lifecycle+Events+Javascript+Bridge
 * @returns
 */
export const NmaBridge = () => {
  useEffect(() => {
    notifyNmaOfHybridLifecycleEvent(LifecycleEvent.READY_TO_DISPLAY);
  }, []);
  return null;
};
